import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../core/services/dataBean/useDataBean';
import { _ConceptCatalogByProcess } from '../../../../../../core/services/dataBean/EntityCatalogVdos';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    proccestype?: number; // este prop se usa si se proporciona
}
export const SelectAccountantConceptCatalogByProcess = ({ idSelector, onChange, label, returnType, proccestype }: Props) => {

    const { instance, lista, setLista } = useDataBean(_ConceptCatalogByProcess)
    const [id, setID] = useState(idSelector);

    useEffect(() => {
        getLista();
    }, [proccestype])

    useEffect(() => {
        if (idSelector != id) {
            setID(idSelector);
        }
    }, [idSelector])

    const setValue = (e) => {
        const selectedId = e;
        // setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDAccountantConcept == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    const getLista = () => {
        const processTypeToUse = proccestype ?? 18; // usa el que venga, si no 18
        instance.getAccountantConceptCatalogByProcess(processTypeToUse).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        ).catch(err => { console.log(err) })
    }

    return (
        <>
            <label>{label ? label : 'Concepto de Ingreso'}</label>
            <select className="form-select" value={id} onChange={(e) => {
                const value = e.target.value ? Number(e.target.value) : null
                setValue(value)
            }}>
                <option value={""} >...</option>
                {lista &&
                    lista.map((item: any) => {
                        return (
                            <option key={item.DataBeanProperties.IDAccountantConcept} value={item.DataBeanProperties.IDAccountantConcept} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}